$ = require 'jquery'
ApiAjax = require 'app/scripts/network/api-ajax'
Auth = require 'app/scripts/db/auth'
Confirm = require 'app/scripts/views/lib/confirm'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'

module.exports = class ChangeRolePopoverView extends View
  viewTitleKey: 'change permissions'

  initialize: ->
    @parent = @options.parent
    @listenTo @parent, 'change:memberships', @render
    return

  events:
    'click .js-make-admin': 'makeAdmin'
    'click .js-make-member': 'makeMember'
    'click .js-make-observer': 'makeObserver'

  render: ->
    view = @
    data = @model.getMembershipData(@parent)

    data.showObserver = @parent.hasObservers()
    data.canMakeAdmin = @model.get('confirmed')

    localizationKey = if @parent.typeName == 'Organization'
      'org roles'
    else if @parent.typeName == 'Board'
      'board roles'
    else
      throw new Error("A fragile abstraction has broken")

    for role in @parent.getAvailableRoles()
      data["roleText_#{role}"] = l([localizationKey, role, 'text'])
    data["roleText_admin"] ?= data["roleText_superadmin"]

    @$el.html(
      templates.fill(
        'popover_change_roles',
        data
      )
    )

    @

  apiChangeRole: (type) ->
    @$el.find('ul a').addClass('disabled')
    @parent.changeMemberRole(@model, { type }).done()
    PopOver.hide()

    return

  getMemberType: -> @parent.getExplicitMemberType(@model)
  isAdminAndMe: -> (@getMemberType() == 'admin') and Auth.isMe(@model)
  isEnterpriseAdmin: -> @parent.getEnterprise?()?.isAdmin(@model)

  makeAdmin: (e) ->
    Util.stop(e)
    return if $(e.target).closest('a').hasClass('disabled')

    @apiChangeRole('admin') if !(@getMemberType() == 'admin')

    return

  makeMember: (e) ->
    Util.stop(e)
    return if $(e.target).closest('a').hasClass('disabled')

    if !(@getMemberType() == 'normal')

      if @isAdminAndMe() && !@isEnterpriseAdmin()
        Confirm.pushView 'demote admin to normal member',
          fxConfirm: (e) =>
            @apiChangeRole('normal')

      else
        @apiChangeRole('normal')

    return

  makeObserver: (e) ->
    Util.stop(e)
    return if $(e.target).closest('a').hasClass('disabled')

    if !(@getMemberType() == 'observer')

      if @isAdminAndMe()
        Confirm.pushView 'demote admin to observer',
          fxConfirm: (e) =>
            @apiChangeRole('observer')

      else
        @apiChangeRole('observer')

    return
